module.exports = __webpack_public_path__ + "static/media/diagon.3596bac9.webp";